import * as React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

import { FilterBox } from "./FilterBox";
import { FilterUtils } from "./FilterUtils";
import { LibraryUtils } from "../LibraryContainer/LibraryUtils";
import { Library } from "../LibraryContainer/Library";

import { Card } from "../Card/Card";

// Init on message for url filters
let tickApplyFilter = null;


const initData = () => {
    for (let key in window.Configs.filters) {
        if (window.Configs.filters[key]["type"] == "checkbox") {
            window.Configs.filter_list[key] = {};
        } else if (window.Configs.filters[key]["type"] == "range") {
            window.Configs.filter_list[key] = [window.Configs.filters[key]["min"], window.Configs.filters[key]["max"]];
        }
    };

    Object.keys(window.Configs.cards).map((key) => {
        // Init card components
        window.Configs.component_cards[window.Configs.cards[key]['name']] = <Card 
            key = {key}
            data = {window.Configs.cards[key]}
        />

        // Set checkbox of filter_list to false
        for (let spec of Object.keys(window.Configs.cards[key]['specs'])) {
            if (spec != "hidden_info") {
                let label = window.Configs.cards[key]['specs'][spec]['key'];
                let value = window.Configs.cards[key]['specs'][spec]['value'];

                if (Array.isArray(value)) {
                    value.map((cb_val) => {
                        window.Configs.filter_list[spec][cb_val] = false;
                    })
                }
            }
        }
    });
};


export const Filter = () => {
    // Init state
    const [init, setInit] = React.useState(true);
    const [fetched, setFetched] = React.useState(false);

    // Update this to affect search
    const [sortFilteredItems, setSortFilteredItems] = React.useState(Object.keys(window.Configs.cards).map((key) => window.Configs.cards[key]));

    // Filter helper states
    const [filterType, setFilterType] = React.useState("instant");
    const [noItemsMessage, setNoItemsMessage] = React.useState("");

    let filterCheckboxCounts = FilterUtils.countCheckboxFilter(sortFilteredItems);


    const editFilterFromUrl = (
        param_key: any,
        extracted_param: any
    ) => {
        if (Array.isArray(window.Configs.filter_list[param_key])) {
            const [min, max] = [
                parseFloat(extracted_param[0]),
                parseFloat(extracted_param[1]),
            ];

            window.Configs.filter_list[param_key] = [
                min < window.Configs.filter_list[param_key][0]
                    ? window.Configs.filter_list[param_key][0]
                    : min,

                max > window.Configs.filter_list[param_key][1]
                    ? window.Configs.filter_list[param_key][1]
                    : max,
            ];
            setFilterType("instant");

        } else {
            let cloned_filter = structuredClone(window.Configs.filter_list[param_key]);
            Object.keys(cloned_filter).map((entry) => {
                if (extracted_param.includes(entry.toLowerCase()))
                    cloned_filter[entry] = true;
            });

            // filter_states[param_key]["set_state"](cloned_filter);
            window.Configs.filter_list[param_key] = cloned_filter;
            setFilterType("instant");
        }
    }

    // filter methods
    const applyFilters = () => {
        if (fetched) {
            tickApplyFilter = null;

            let filtered_list = Object.keys(window.Configs.cards).map((key) => window.Configs.cards[key]);
            let search_input = document.getElementById("search-input") as HTMLInputElement;
            if(search_input.value.length > 0)
                filtered_list = LibraryUtils.searchWithList(filtered_list);


            // for(const key in parameters) {
            // for(const key in filter_values) {
            for(const key in window.Configs.filter_list) {
                let temp = FilterUtils.applyFiltersToCards(
                    key, window.Configs.filter_list[key], filtered_list
                );

                if(temp.length > 0)
                    filtered_list = temp;
            }

            if(filtered_list.length == 0) {
                setNoItemsMessage("No items match your filter.");
            } else {
                setNoItemsMessage("");
            }

            filterCheckboxCounts = FilterUtils.countCheckboxFilter(filtered_list);

            applyFiltersToUrl();

            setSortFilteredItems(filtered_list);
            setFilterType("");
        }
    }

    const applyFiltersSchedule = () => {
        if(tickApplyFilter != null) {
            clearTimeout(tickApplyFilter);
        };
        tickApplyFilter = setTimeout(applyFilters, 100);
    };

    const applyFiltersToUrl = () => {
        let hash_str = "";
        let query_symbol = "#filter?";
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        const filter_strings = {}

        for (let key in window.Configs.filter_list) {
            filter_strings[key] = window.Configs.filter_list[key];
        }

        // name
        if(search_input.value.length > 0) {
            hash_str += query_symbol + "name=" + search_input.value.trim().toLowerCase().split(" ").join("+");
            query_symbol = "&";
        }

        // checkbox and slider
        Object.keys(filter_strings).map((string) => {
            let temp_hash = editUrlFilter(
                string, 
                filter_strings[string], 
                query_symbol
            );

            if(temp_hash != undefined) {
                hash_str += temp_hash;
                query_symbol = "&";
            }
        });

        // Only change hash when not init because
        // on init the hash is empty and it will reset
        // the hash to empty, this will make the saved urls
        // with filters not working properly
        if(!init) {
            window.location.hash = hash_str;
        }
    }

    const editUrlFilter = (
        filter_string: string,
        filter: any,
        query_symbol: string,
    ) => {
        if(Array.isArray(filter)) {
            if (
                filter[0] > window.Configs.filters[filter_string]["min"] ||
                filter[1] < window.Configs.filters[filter_string]["max"]
            )
                return query_symbol + filter_string + "=" + filter[0] + "-" + filter[1];

        } else {
            let checked_values = [];
            Object.keys(filter).map((entry) => {
                if (filter[entry]) {
                    let temp_value = entry.trim().toLowerCase().split(" ").join("-");
                    if(temp_value == "ext.-axis") temp_value = "ext.axis"
                    checked_values.push(temp_value);
                }
            });
            if (checked_values.length > 0) {
                return query_symbol + filter_string + "=" + checked_values.join("+");
            }
        }
    };

    const clearFilters = () => {
        initData();
        setFilterType("instant");
    };

    const clearSearchParameters = () => {
        (document.getElementById("search-input") as HTMLInputElement).value = "";
       
        applyFilters();
        setFilterType("instant");
    };

    // Checkbox filter handler
    const handleCBChangeFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        Object.keys(window.Configs.filter_list).map((key) => {
            if (Object.keys(window.Configs.filter_list[key]).includes(e.currentTarget.name)) {
                let new_filter = structuredClone(window.Configs.filter_list[key]);
                new_filter[e.currentTarget.name] = e.currentTarget.checked;
                window.Configs.filter_list[key] = new_filter;
                setFilterType("instant");
            }
        })
    };

    const initFilterFromUrl = () => {
        FilterUtils.extractUrlQueryOnMessage(window.location.hash);

        // Apply filters
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(FilterUtils.extracted_params.hasOwnProperty("name"))
            search_input.value = FilterUtils.extracted_params['name'];

        Object.keys(FilterUtils.extracted_params).map((key) => {
            if(key != "name") {
                editFilterFromUrl(
                    key,
                    FilterUtils.extracted_params[key]
                ) 
            }
        });
    }

    React.useEffect(() => {
        if (window.Settings.LOCAL_BUILD) {
            window.Configs.library = require("../../utils/config.json");
            window.Configs.filters = require("../../utils/filter-specs.json");
            window.Configs.cards = require("../../utils/cards.json");

            initData();
            initFilterFromUrl();
            
            setInit(false);
            setFetched(true);

        } else {
            const fetchConfigs = async () => {
                await fetch('./config.json')
                .then((res) => res.json())
                .then((data) => window.Configs.library = data);

                await fetch('./filter-specs.json')
                .then((res) => res.json())
                .then((data) => window.Configs.filters = data);

                await fetch('./cards.json')
                .then((res) => res.json())
                .then((data) => window.Configs.cards = data);

                initData();
                initFilterFromUrl();

                // Change init
                setInit(false);
                setFetched(true);
            };

            fetchConfigs();
        }
    }, []);

    React.useEffect(() => {
        if(filterType == "delay")
            applyFiltersSchedule()

        else if(filterType == "instant")
            applyFilters();
    });

    // TODO: Replace with proper loading screen
    if (!fetched) return <>fetching</>;

    return (
        <>
            <div className="title sticky-top">
                <h1 style={{ marginBottom: 0 }}>
                    {window.Configs.library['title']}
                </h1>
            </div>

            <div className="main-container container-fluid">
                <div className="row">
                    <div className="col col-12 col-sm-12 col-lg-3">
                        <div
                            className="filter-form sticky-top"
                        >
                            <div id="search-row">
                                <form id="search-bar">
                                    <input
                                        id="search-input"
                                        type="text"
                                        placeholder="Search library"
                                    />
                                    <div id="search-bar-action-btns">
                                        <button
                                            id="search-button"
                                            onClick={(e: React.MouseEvent) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                applyFilters();
                                            }}
                                        >
                                            <img
                                                width="auto"
                                                height="18rem"
                                                // src={window.Paths.LIB_ASSETS + "magnifier.png"}
                                                src={"lib_assets/magnifier.png"}
                                            />
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <div className="section-top">
                                <a
                                    className="btn center-block"
                                    onClick={clearFilters}
                                >
                                    {"Clear filters"}
                                </a>
                                <a
                                    className="btn center-block"
                                    style={{ marginLeft: ".5rem" }}
                                    onClick={clearSearchParameters}
                                >
                                    {"Clear search"}
                                </a>
                                <a
                                    className="btn center-block"
                                    style={{ marginLeft: ".5rem" }}
                                    onClick={(e: React.MouseEvent) => {
                                        clearFilters();
                                        clearSearchParameters();
                                    }}
                                >
                                    {"Clear all"}
                                </a>
                            </div>
                            <div className="filters">
                                {Object.keys(window.Configs.filters).map((key, index) => {
                                    if (window.Configs.filters[key]["type"] == "checkbox") {
                                        return (
                                            <FilterBox
                                                key = {"cb-filter-" + key }
                                                first = {index == 0 ? true : false}
                                                type = {"checkbox"}
                                                filter_key = {key} 
                                                data = {window.Configs.filter_list[key]}
                                                count = {filterCheckboxCounts[key]}
                                                state = {window.Configs.filter_list[key]}
                                                handler = {handleCBChangeFilter}
                                            />
                                        );
                                    } else if (window.Configs.filters[key]["type"] == "range") {
                                        return (
                                            <FilterBox 
                                                key = {"range-filter-" + key} 
                                                first = {index == 0 ? true : false}
                                                type = {"range"}
                                                filter_key = {key} 
                                                data = {window.Configs.filters[key]}
                                                state = {window.Configs.filter_list[key]}
                                                handler = {(values: Array<number>) => {
                                                    window.Configs.filter_list[key] = values;
                                                    setFilterType("instant");
                                                }}
                                            />
                                        );
                                    }
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="col col-12 col-sm-12 col-lg-9">
                        <Library
                            noItemsMessage = {noItemsMessage}
                            sortFilteredItems = {sortFilteredItems}
                        />
                    </div>
                </div>
            </div>
        </>
        // )}
    );
};
